import type { TargetareFiltre } from "@/types/targetare";

export function filtreTargetareToQuery(
  filtre: TargetareFiltre
): URLSearchParams {
  const query = new URLSearchParams();
  if (filtre.tier?.length) query.set("tier", filtre.tier.join(","));
  if (filtre.dimensiune?.length) {
    query.set("dimensiune", filtre.dimensiune.join(","));
  }
  if (filtre.sector) query.set("sector", filtre.sector);
  if (filtre.judet) query.set("judet", filtre.judet);
  if (filtre.q?.trim()) query.set("q", filtre.q.trim());
  if (filtre.doar_cu_email) query.set("doar_cu_email", "true");
  if (filtre.doar_cu_telefon) query.set("doar_cu_telefon", "true");
  if (filtre.doar_scop_dimensiune) query.set("doar_scop_dimensiune", "true");
  if (filtre.actionariat?.length) {
    query.set("actionariat", filtre.actionariat.join(","));
  }
  if (filtre.include_fara_tier) query.set("include_fara_tier", "true");
  if (typeof filtre.scor_min === "number") {
    query.set("scor_min", String(filtre.scor_min));
  }
  if (filtre.sort) query.set("sort", filtre.sort);
  return query;
}

export function numarFiltreActive(filtre: TargetareFiltre): number {
  return [
    filtre.tier?.length,
    filtre.dimensiune?.length,
    filtre.sector,
    filtre.judet,
    filtre.q?.trim(),
    filtre.doar_cu_email,
    filtre.doar_cu_telefon,
    filtre.include_fara_tier,
    typeof filtre.scor_min === "number",
  ].filter(Boolean).length;
}
